import {
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  golfstatusColors,
  GSButton,
  GSInfoGroup,
  GSItemList,
  useMediaQuery,
} from "golfstatus_react_components";
import {
  faBan,
  faCircleCheck,
  faSpinner,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { getV3DateTimeOn } from "../../../helpers/Dates";
import { displayPlayerHandicap, displayTeamHandicap } from "../../../helpers/Handicaps";

const CENTER = "center";

const TournamentTeamCheckInItem = (props) => {
  const {
    holeAssignment,
    roundCheckIn,
    nameOrContact,
    players,
    team,
    tournament,
    flight,
    mainLeaderboardScoreDetails,
    disqualified,
    style,
    checkInClick,
    checkOutClick,
    checkPlayerInClick,
    checkPlayerOutClick,
    pending,
    isDisabled,
    entryCode,
    playerCheckins,
  } = props;

  const { isPhone, isTablet } = useMediaQuery();

  const contactInfo = {
    sectionItems: [
      {
        type: "primary full-width capitalize",
        value: `${nameOrContact} ${displayTeamHandicap(team, tournament)}`,
      },
      {
        type: "secondary full-width capitalize",
        value: entryCode,
      },
    ],
  };

  const getPlayerButton = (player) => {
    const playerCheckIn = playerCheckins?.find?.(
      (cip) => cip?.player?.id === player?.id,
    );
    const playerCheckedIn = playerCheckIn?.checkedInAt;

    if(pending?.some?.(
                  (n) => n?.payload?.meta?.arg === playerCheckIn?.id,
                )){
      return <GSButton type="secondary grey pill" buttonIcon={faSpinner} />
    }

    return (
      <GSButton
        style={
          playerCheckedIn
            ? {
                backgroundColor: golfstatusColors.grey800,
                color: golfstatusColors.white,
                transition: ".3s",
              }
            : {
                backgroundColor: golfstatusColors.grey100,
                transition: ".3s",
              }
        }
        type={`secondary ${playerCheckedIn ? "pill" : ""}`}
        buttonIcon={playerCheckedIn ? faUserCheck : faCircleCheck}
        onClick={() => {
          if (playerCheckedIn) {
            checkPlayerOutClick?.(playerCheckIn);
          } else {
            checkPlayerInClick?.(playerCheckIn);
          }
        }}
      />
    );
  };

  const playerInfo = {
    sectionItems: [
      {
        type: " full-width",
        value: (
          <GSItemList
            type="vertical small-gap"
            items={players}
            listItem={(player) => {
              return (
                <div
                  style={{
                    ...defaultLayouts.hStack.align(CENTER, CENTER),
                    ...defaultGapping.mediumGap,
                  }}
                >
                  {getPlayerButton(player)}
                  <div
                    style={{ ...defaultTypography.bodyRegular.withOpacity() }}
                  >{`${player.name} ${displayPlayerHandicap(
                    player,
                    tournament,
                  )}`}</div>
                </div>
              );
            }}
          />
        ),
      },
    ],
  };

  const holeAssignmentInfo = {
    style: { alignItems: isPhone() || isTablet() ? "flex-start" : "flex-end" },
    sectionItems: [
      {
        type: " no-wrap",
        style: { fontWeight: "bold" },
        value: `Hole ${holeAssignment?.hole} ${holeAssignment.position} ${
          holeAssignment.subPosition ? holeAssignment?.subPosition : ""
        }`,
      },
      {
        type: "secondary no-wrap",
        value: `${getV3DateTimeOn(holeAssignment.teeTime)}`,
      },
      {
        type: "secondary no-wrap",
        value: `${holeAssignment?.roundCourse?.name}`,
      },
    ],
  };

  const checkinItem = {
    style: { alignItems: isPhone() || isTablet() ? "flex-start" : "flex-end" },
    sectionItems: [
      {
        type: "primary",
        value: (
          <GSButton
            isDisabled={isDisabled}
            type="grey"
            title="Check In"
            buttonIcon={faCircleCheck}
            onClick={() => {
              checkInClick?.(roundCheckIn);
            }}
          />
        ),
      },
    ],
  };

  const checkedInItem = {
    style: { alignItems: isPhone() || isTablet() ? "flex-start" : "flex-end" },
    sectionItems: [
      {
        type: "primary",
        value: (
          <GSButton
            isDisabled={isDisabled}
            type="black pill secondary"
            title="Checked In"
            buttonIcon={faUserCheck}
            onClick={() => {
              checkOutClick?.(roundCheckIn);
            }}
          />
        ),
      },
    ],
  };

  const checkedInPendingItem = {
    style: { alignItems: isPhone() || isTablet() ? "flex-start" : "flex-end" },
    sectionItems: [
      {
        type: "primary",
        value: (
          <GSButton type="grey pill" title="Check In" buttonIcon={faSpinner} />
        ),
      },
    ],
  };

  const flightInfo = {
    sectionItems: [
      {
        type: "secondary",
        value: `${flight?.name} flight`,
      },
    ],
  };

  const teamColumn = {
    fit: "stretch",
    sections: [contactInfo, playerInfo],
  };

  const getButton = () => {
    if (pending?.some?.(
                  (n) => n?.payload?.meta?.arg === roundCheckIn?.id,
                )) {
      return checkedInPendingItem;
    } else if (roundCheckIn?.checkedInAt) {
      return checkedInItem;
    } else return checkinItem;
  };

  const checkinColumn = {
    sections: [holeAssignmentInfo, getButton()],
  };

  const dqColumn = {
    fit: "fit",
    sections: [
      {
        sectionItems: [
          {
            type: "primary",
            value: (
              <GSButton
                type="secondary status pill orange"
                title="Disqualified"
                buttonIcon={faBan}
              />
            ),
          },
        ],
      },
    ],
  };

  if (mainLeaderboardScoreDetails?.position) {
    flightInfo.sectionItems.unshift({
      type: "secondary",
      value: mainLeaderboardScoreDetails?.position,
    });
  }

  if (flight) {
    teamColumn.sections.push(flightInfo);
  }

  const getGroup = () => {
    let group = [teamColumn, checkinColumn];
    if (disqualified) {
      group.push({ ...dqColumn });
    }
    return group;
  };

  return (
    <tournament-team-check-in-item style={style}>
      <GSInfoGroup
        listType="mobile-vertical"
        dataGroups={getGroup()}
      ></GSInfoGroup>
    </tournament-team-check-in-item>
  );
};

export default TournamentTeamCheckInItem;
